<template>
  <div class="row">
    <div class="col-sm-6">
      <vue-chosen
        v-model="status"
        :name="'filter_' + fieldKey + '[status][]'"
        :options="lists.statuses"
        :multiple="true"
        class="form-control"
        placeholder="Deployment status ..."
      ></vue-chosen>
    </div>
    <div class="col-sm-1"> for </div>
    <div class="col-sm-5">
      <vue-chosen
        v-model="storm"
        :name="'filter_' + fieldKey + '[storm][]'"
        :options="lists.storms"
        :multiple="true"
        class="form-control"
        placeholder="Storm ..."
      ></vue-chosen>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    operator: {type: String, required: true},
    fieldKey: {type: String, required: true},
    fieldValue: {type: [String, Object], default: ''},
    statuses: {type: Object, default: function () { return {} }},
    storms: {type: Array, default: function () { return [] }},
  },

  /**
   * Variables (models).
   */
  data () {
    return {
      status: this.fieldValue.status ?? '',
      storm: this.fieldValue.storm ?? '',
      lists: {
        'statuses': this.statuses,
        'storms': this.storms,
      },
    }
  },

}
</script>
